import { render, staticRenderFns } from "./SignUpWelcomeMsg.vue?vue&type=template&id=266326fb&"
import script from "./SignUpWelcomeMsg.vue?vue&type=script&lang=js&"
export * from "./SignUpWelcomeMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports